export default "__VITE_ASSET__DSvX6cLX__"